import React from 'react';

import cx from 'classnames';
import { SocialMediaLinks } from 'themes/common/components/NavItemSocial/SocialMediaLinks';

import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

import { useBusiness } from 'hooks/business/useBusiness';
import { useNavigation } from 'hooks/navigation/useNavigation';

import { PlayfulNavItem } from './PlayfulNavItem';

import s from './PlayfulNavigation.module.css';

export const PlayfulNavigation = () => {
  const { isMultiUser } = useBusiness();
  const {
    showPortfolio,
    showTeam,
    shopUrl,
    bookUrl,
    contactUrl,
    aboutUrl,
    teamUrl,
    servicesUrl,
    portfolioUrl,
    packagesUrl,
    tracking,
    socialMediaUrls,
  } = useNavigation();

  const showTeamOnWebsite = showTeam && isMultiUser;
  const { isEnabled: isNileEnabled } = useFeatureFlag(FEATURE_FLAGS.NILE_PILOT);

  const navClassNames = cx(s.itemContainer);

  return (
    <nav className={s.nav} role="navigation" aria-label="subsection navigator">
      <div className={navClassNames}>
        <ul className={s.menu}>
          <li>
            <PlayfulNavItem
              onClick={() => tracking.navItemClicked('about')}
              href={aboutUrl}
            >
              about
            </PlayfulNavItem>
          </li>
          {showTeamOnWebsite && (
            <li>
              <PlayfulNavItem
                onClick={() => tracking.navItemClicked('team')}
                href={teamUrl}
              >
                our team
              </PlayfulNavItem>
            </li>
          )}
          <li>
            <PlayfulNavItem
              onClick={() => tracking.navItemClicked('services')}
              href={servicesUrl}
            >
              services
            </PlayfulNavItem>
          </li>
          {showPortfolio && (
            <li>
              <PlayfulNavItem
                onClick={() => tracking.navItemClicked('portfolio')}
                href={portfolioUrl}
              >
                portfolio
              </PlayfulNavItem>
            </li>
          )}
          {packagesUrl && (
            <li>
              <PlayfulNavItem
                onClick={() => tracking.navItemClicked('packages')}
                href={packagesUrl}
              >
                packages
              </PlayfulNavItem>
            </li>
          )}
          <li>
            <PlayfulNavItem
              onClick={() => tracking.navItemClicked('contact')}
              href={contactUrl}
            >
              contact
            </PlayfulNavItem>
          </li>
          {isNileEnabled && (
            <li>
              <PlayfulNavItem
                onClick={() => tracking.navItemClicked('shop')}
                href={shopUrl}
                newTab
              >
                Shop Now
              </PlayfulNavItem>
            </li>
          )}
          <li className={s.highlightedContainer}>
            <PlayfulNavItem
              onClick={() => tracking.navItemClicked('book')}
              href={bookUrl}
              highlighted
            >
              book
            </PlayfulNavItem>
          </li>

          <li>
            <SocialMediaLinks className={s.socials} urls={socialMediaUrls} />
          </li>
        </ul>
      </div>
    </nav>
  );
};
